export const experienceData = [
    {
        id: 1,
        company: 'Germantown Technologies India Pvt Ltd',
        jobtitle: 'Software Engineer',
        startYear: '2022',
        endYear: '2023'
    },
    {
        id: 2,
        company: 'Datinfi Private Limited',
        jobtitle: 'Product Development Engineer',
        startYear: '2021',
        endYear: '2022'
    },
    // {
    //     id: 3,
    //     company: 'Wonka Industries',
    //     jobtitle: 'Marketing',
    //     startYear: '2020',
    //     endYear: 'Present'
    // },
]